<ng-container *transloco="let t">
  <div class="modal-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center cursor-pointer" (click)="onClose()">
      <img src="assets/icons/icons-alt/modal-back-button.svg" alt="Bookmark" class="pe-2"/>
      <span class="text-uppercase">
                {{ t('app.common.back') }}
        </span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    <div class="px-2 pb-3">
      <div class="pb-3">
        <h3 class="text-uppercase fst-normal">{{
            ((competitorResults?.firstName ?? "")| titlecase) + " " + ((competitorResults?.lastName ?? "") | titlecase)
          }}</h3>
        <span>{{ t('competitor.table.start.number') + ": " }}</span><span
        class="fw-medium">{{ competitorResults.startNumber }}</span>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th scope="col">{{ t('app.common.gender') }}</th>
            <th scope="col">{{ t('race.registration.settings.clubSchoolTeam') }}</th>
            <th scope="col">{{ t('app.common.country') }}</th>
            <th scope="col">{{ t('app.common.status') }}</th>
            <th scope="col">{{ t('competitor.table.end.time') }}</th>
            <th scope="col">{{ t('competitor.table.time') }}</th>
            <th scope="col">{{ t('competitor.table.tempo') }}</th>
            <th scope="col">{{ t('competitor.table.speed') }}</th>
            <th scope="col">{{ t('competitor.table.absolute.rank') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="d-flex justify-content-center">
                @if (competitorResults.sex === 1) {
                  <div class="badge-holder__badge gender-badge-man">
                <span class="text-uppercase">
                        {{ t("app.common.gender.short.1") }}
                </span>
                  </div>
                } @else if (competitorResults.sex === 2) {
                  <div class="badge-holder__badge gender-badge-women">
                <span class="text-uppercase">
                        {{ t("app.common.gender.short.2") }}
                </span>
                  </div>
                } @else {
                  <div class="badge-holder__badge gender-badge-man">
                <span class="text-uppercase">
                        {{ "-" }}
                </span>
                  </div>
                }
              </div>
            </td>
            <td>
              {{ competitorResults.club ? competitorResults.club : "-" }}
            </td>
            <td>
              {{ competitorResults.country ? competitorResults.country : "-" }}
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="badge-holder__badge finished">
                  <span class="text-uppercase">
                    {{ competitorResults.status ? competitorResults.status : "-" }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              {{ competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType }}
            </td>
            <td>
              {{ competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType }}
            </td>
            <td>
              {{ competitorResults.competitorResultsDetail | competitorTempo:race }}
            </td>
            <td>
              {{ competitorResults.competitorResultsDetail | competitorSpeed:race }}
            </td>
            <td>
              <div class="d-flex flex-row justify-content-center">
                <div class="badge-holder__badge rank-badge">
                  <span class="text-uppercase">
                          {{ competitorResults | rank:category:gender:measurementType }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="pb-3 pt-4">
        <h3 class="text-uppercase fst-normal">{{
            isRoundRace ? t("competitor.table.laps") : t("app.common.controlPoints")
          }}</h3>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th scope="col">{{ t('competitor.table.type') }}</th>
            <th scope="col">{{ t('competitor.table.end.time') }}</th>
            <th scope="col">{{ t('competitor.table.time') }}</th>
            <th scope="col">{{ t('competitor.table.difference') }}</th>
            @if (!isRoundRace) {
              <th scope="col">{{ t('competitor.table.absolute.rank') }}</th>
            }
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="d-flex">
                <div class="badge-holder__badge in-progress">
                  <span class="text-uppercase">
                    {{ t('organiser.event.details.control.point.waypointType.3') }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              {{
                competitorResults?.competitorResultsDetail?.st_tm|
                  resultDateTime:competitorResults?.competitorResultsDetail?.st_dc:race?.raceSettings?.measurementPrecisionType
              }}
            </td>
            <td>
              -
            </td>
            <td>
              -
            </td>
            @if (!isRoundRace) {
              <td class="text-center">
                -
              </td>
            }
          </tr>
            @if (isRoundRace && list.length > 0) {
              <tr *ngFor="let competitorStageDetail of list">
                <td>
                  {{ t('measurements.lap.label', {lap: competitorStageDetail.lp}) }}
                </td>
                <td>
                  {{ competitorStageDetail?.ps_tm | resultDateTime:competitorStageDetail?.ps_dc:race?.raceSettings?.measurementPrecisionType }}
                </td>
                <td>
                  {{ competitorStageDetail?.nt_tm | resultTime }}
                </td>
                <td>
                  {{ competitorStageDetail?.lp_tm|resultTime:race?.raceSettings?.measurementPrecisionType }}
                </td>
              </tr>
            } @else if (!isRoundRace && checkpointsIds.length > 0) {
              <tr *ngFor="let cp_id of checkpointsIds;">
                <td>
                  {{
                    SGS![cp_id]|waypointNameByWaypointId
                  }}
                </td>
                <td>
                  {{ SGS![cp_id]?.ps_tm | resultDateTime:SGS![cp_id]?.ps_dc:race?.raceSettings?.measurementPrecisionType }}
                </td>
                <td>
                  {{ SGS![cp_id]?.tl_tm|resultTime:race?.raceSettings?.measurementPrecisionType }}
                </td>
                <td>
                  {{ SGS![cp_id]?.nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType }}
                </td>
                <td>
                  <div class="d-flex flex-row justify-content-center">
                    <div class="badge-holder__badge rank-badge">
                      <span class="text-uppercase">
                              {{ SGS![cp_id] | rank:category:gender:measurementType:true }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (!isRoundRace) {
              <tr>
                <td>
                  <div class="d-flex">
                    <div class="badge-holder__badge finished">
                      <span class="text-uppercase">
                      {{ t('organiser.event.details.control.point.waypointType.4') }}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  {{ competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType }}
                </td>
                <td>
                  @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                    {{ competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType }}
                  } @else {
                    {{ "-" }}
                  }
                </td>
                <td>
                  @if (this.sgsFinishItem && competitorResults.status === CompetitorStatus.FIN) {
                    {{ sgsFinishItem?.nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType }}
                  } @else if (competitorResults.status === CompetitorStatus.FIN) {
                    {{ competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType }}
                  } @else {
                    -
                  }
                </td>
                <td>
                  @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                    <div class="d-flex flex-row justify-content-center">
                      <div class="badge-holder__badge rank-badge">
                      <span class="text-uppercase">
                              {{ competitorResults | rank:category:gender:measurementType }}
                      </span>
                      </div>
                    </div>
                  } @else {
                    {{ "-" }}
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>
